var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptimalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-approved-5361375 1",
    clipPath: "url(#clip0_1677_13594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 0.833252C11.955 0.833252 15.1663 4.04459 15.1663 7.99992C15.1663 11.9553 11.955 15.1666 7.99967 15.1666C4.04434 15.1666 0.833008 11.9553 0.833008 7.99992C0.833008 4.04459 4.04434 0.833252 7.99967 0.833252ZM7.99967 1.83325C4.59634 1.83325 1.83301 4.59659 1.83301 7.99992C1.83301 11.4033 4.59634 14.1666 7.99967 14.1666C11.403 14.1666 14.1663 11.4033 14.1663 7.99992C14.1663 4.59659 11.403 1.83325 7.99967 1.83325Z",
    fill: "#2AD033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79785 8.18652C4.60254 7.99182 4.60254 7.67454 4.79785 7.47985C4.99315 7.28454 5.30982 7.28454 5.50519 7.47985L7.25653 9.23118L10.4792 5.70785C10.6659 5.50452 10.9825 5.48982 11.1859 5.67649C11.3892 5.86248 11.4039 6.17915 11.2172 6.38248L7.64122 10.2918C7.54924 10.3925 7.41985 10.4511 7.28387 10.4545C7.1472 10.4571 7.01584 10.4045 6.91917 10.3078L4.79784 8.18647L4.79785 8.18652Z",
    fill: "#2AD033"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_13594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimalIcon);
export default __webpack_public_path__ + "static/media/optimal-icon.0f96fa27b10757f365acce5dea93be5e.svg";
export { ForwardRef as ReactComponent };